// frontend/src/utils/refreshUtils.js
// Utility functions for forcing data refresh

export const forceRefreshAllProducts = () => {
    // Clear any cached data in localStorage/sessionStorage
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.includes('product') || key.includes('featured'))) {
            keysToRemove.push(key);
        }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // Clear sessionStorage as well
    const sessionKeysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && (key.includes('product') || key.includes('featured'))) {
            sessionKeysToRemove.push(key);
        }
    }
    sessionKeysToRemove.forEach(key => sessionStorage.removeItem(key));
    
    console.log('Cleared product-related cache data');
    
    // Force page reload to clear all caches
    window.location.reload(true);
};

export const addRefreshTimestamp = (url) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}_refresh=${Date.now()}&_random=${Math.random().toString(36).substring(7)}`;
};

export const isProductUrl = (url) => {
    return url && (url.includes('/products') || url.includes('/product/'));
};

// Global function for browser console debugging
if (typeof window !== 'undefined') {
    window.forceRefreshProducts = forceRefreshAllProducts;
    window.clearProductCache = () => {
        console.log('Clearing all product caches...');
        forceRefreshAllProducts();
    };
    
    // Add a function to test API calls
    window.testProductAPI = async () => {
        try {
            const response = await fetch('/api/v1/products?_test=' + Date.now());
            const data = await response.json();
            console.log('API Test Response:', data);
            return data;
        } catch (error) {
            console.error('API Test Error:', error);
        }
    };
}
